import { render, staticRenderFns } from "./ModalNewUser.vue?vue&type=template&id=682251f2&scoped=true"
import script from "./ModalNewUser.vue?vue&type=script&lang=js"
export * from "./ModalNewUser.vue?vue&type=script&lang=js"
import style0 from "./ModalNewUser.vue?vue&type=style&index=0&id=682251f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682251f2",
  null
  
)

export default component.exports